(function () {
	'use strict';

	ExportModelListController.$inject = [
		'$log',
		'$state',
		'$rootScope',
		'$scope',
		'NgExportTemplate',
		'PermissionService',
		'DcElementListService',
	];

	function ExportModelListController(
		$log,
		$state,
		$rootScope,
		$scope,
		NgExportTemplate,
		PermissionService,
		DcElementListService
	) {
		const vm = this;
		const listeners = [];
		vm.elems = [];
		vm.selectedElems = [];
		vm.showActiveElementOnly = false;
		vm.disableAllSelectedElems = true;
		vm.createAuthorised = false;
		vm.exportTemplateAuthorised = false;
		vm.checkPermissionData = {};
		vm.permissionData = {};

		vm.$onInit = onInit;
		vm.$onDestroy = onDestroy;
		vm.createTemplate = create;
		vm.goToExportTemplate = goToExportTemplate;
		vm.deleteTemplate = deleteTemplate;
		vm.refreshGridData = refreshGridData;
		vm.deleteBulkExportTemplates = deleteBulkExportTemplates;
		vm.showPermissions = showPermissions;

		function create() {
			$state.go('export-template-edit', { exportConfigId: -1 });
		}

		function refreshGridData() {
			NgExportTemplate.refreshAvailableExportTemplateList(
				vm.showActiveElementOnly
			);
		}

		function deleteTemplate(element) {
			requireElementPermission(element, 'delete', function () {
				NgExportTemplate.deleteTemplatesById(
					[element.id],
					vm.showActiveElementOnly
				);
			});
		}

		function getGridData() {
			NgExportTemplate.getAvailableExportTemplateList().then((list) => {
				const content = list.elements.toArray();
				const tagsById = new Map();
				vm.elems = content.map(([id, exportTemplateDetails]) => {
					const tags = exportTemplateDetails.tags.toArray();
					tags.forEach((tag) => tagsById.set(tag.id, tag));
					return {
						id: exportTemplateDetails.id,
						metadataId: exportTemplateDetails.metadataId,
						type: exportTemplateDetails.outputType,
						code: exportTemplateDetails.code,
						lc: exportTemplateDetails.label ?? '',
						desc: exportTemplateDetails.description,
						icon_id: exportTemplateDetails.iconId ?? -1,
						tags: tags,
						tagAsArray: tags.map((tag) => tag.label),
						creationDate: $rootScope.getDateTimeWithPattern(
							exportTemplateDetails.creationDate
						),
						updateDate: $rootScope.getDateTimeWithPattern(
							exportTemplateDetails.updateDate
						),
						createdBy: exportTemplateDetails.createdBy,
						updatedBy: exportTemplateDetails.updatedBy,
						project: {
							id: exportTemplateDetails.projectId,
							metadata: {
								label: exportTemplateDetails.projectLabel,
							},
						},
					};
				});

				vm.tags = Array.from(tagsById.values()).map((tag) => ({
					id: tag.id,
					label: tag.label,
				}));

				if (vm.dataGridOptions) {
					vm.dataGridOptions.dataSource = vm.elems;
				}

				vm.selectedElems = [];
				vm.disableAllSelectedElems = true;

				if (vm.gridInstance && vm.gridInstance.option) {
					vm.gridInstance.option('dataSource', vm.elems);
					vm.gridInstance.clearSelection();
					DcElementListService.refreshTagsLookup(vm);
					vm.gridInstance.refresh();
				}
			});
		}

		function goToExportTemplate(element) {
			requireElementPermission(element, 'edit', function () {
				$state.go('export-template-edit', {
					exportConfigId: element.id,
				});
			});
		}

		function deleteBulkExportTemplates() {
			let ids = vm.selectedElems.map((el) => el.id);
			NgExportTemplate.deleteTemplatesById(ids, vm.showActiveElementOnly);
		}

		function checkPermissionsAndLoadList() {
			PermissionService.haveGlobalPermission('export_template-create').then(
				function (response) {
					vm.createAuthorised = response.data;
				}
			);
			// if have permission to load list do it
			PermissionService.haveGlobalPermission('export_template').then(function (
				response
			) {
				vm.exportTemplateAuthorised = response.data;
				if (vm.exportTemplateAuthorised) {
					refreshGridData();
				}
			});
		}

		function onInit() {
			$log.debug('init export models list');
			// Get DxGrid dataGridOptions
			vm.disableAllSelectedElems = true;
			DcElementListService.getDcElementDxList(vm, 'exportTemplate', false);
			// INIT
			checkPermissionsAndLoadList();
			initEvents();
		}

		function onDestroy() {
			$log.debug('destroying component');
			listeners.forEach((cb) => cb());
		}

		function initEvents() {
			const ref = $scope.$on('export-template:list:refresh', function () {
				getGridData();
			});
			listeners.push(ref);
		}

		function requireElementPermission(element, action, onPermitted) {
			vm.checkPermissionData.elementId = element.id;
			vm.checkPermissionData.metadataId = element.metadataId;
			vm.checkPermissionData.label = element.lc;
			vm.checkPermissionData.type = 'export_template';
			vm.checkPermissionData.action = action;
			vm.checkPermissionData.actionIfPermitted = onPermitted;
			vm.checkPermissionData.showPermissionCheck = true;
		}

		function showPermissions(element) {
			requireElementPermission(element, 'permissions', doShowPermissions);
		}

		function doShowPermissions() {
			vm.permissionData.metadataId = vm.checkPermissionData.metadataId;
			vm.permissionData.type = 'export_template';
			vm.permissionData.elementId = vm.checkPermissionData.elementId;
			vm.permissionData.lib = vm.checkPermissionData.label;
			vm.permissionData.showElementPermissions = true;
		}
	}

	const exportTemplateListCmp = {
		restrict: 'E',
		controller: ExportModelListController,
		templateUrl:
			'./src/components/directives/exportTemplate/exportTemplateList.component.html',
		controllerAs: 'vm',
		bindings: {
			isList: '<',
		},
	};

	angular
		.module('MiscellaneousSettingsModule')
		.component('exportTemplateListCmp', exportTemplateListCmp);
})();
